/**
 * useSyncStatus — polls /salescoach/api/sync-status every minute for the top-nav
 * stale dot (Plan 05 Task 5.8).
 *
 * Separate from use-overview.ts because every tab needs it (not just
 * Overview) and it polls on its own cadence. TanStack Query caches the
 * result so all subscribers share one in-flight request.
 */

import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/services/api';

export interface SyncStatusPayload {
  lastSyncedAt: string | null;
  ageMs: number | null;
  totalTraces: number;
  last24hTraces: number;
  oldestTrace: string | null;
}

interface Envelope<T> {
  data: T;
  generated_at: string;
  query_duration_ms: number;
}

/** Fetch wrapper that unwraps the server envelope. */
async function fetchSyncStatus(): Promise<SyncStatusPayload> {
  const res = await apiFetch<Envelope<SyncStatusPayload>>('/salescoach/api/sync-status');
  return res.data;
}

export function useSyncStatus() {
  return useQuery({
    queryKey: ['sync-status'],
    queryFn: fetchSyncStatus,
    // One-minute poll: stale dot is the user's at-a-glance freshness signal,
    // so keeping it current without hammering the backend is the sweet spot.
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}
